<template>
  <div class="talentq-agreement">
    <div class="flex_center agree">
      <vcheckbox v-model="agree_data" class="margin_right" />
      <div
        v-html="
          $tr('vacancy.openRegistration.personalDataAgreement', {
            agreement_link: agreement_link,
            user_agreement_link: user_agreement_link,
            privacy_link: privacy_link,
            cookies_link: cookies_link
          })
        "
      ></div>
    </div>

    <div class="flex_center agree">
      <vcheckbox v-model="agree_video" class="margin_right" />
      <div v-html="$tr('videoInterview.checkVideo.termsVideo')"></div>
    </div>

    <vbutton
      :disabled="!all_agree"
      :label="$tr('interview.tests.init.button.start')"
      @click="$emit('agree')"
    />
  </div>
</template>

<script>
export default {
  name: 'InterviewTalentqTestAgree',

  data() {
    return {
      agree_data: false,
      agree_video: false
    };
  },

  computed: {
    all_agree() {
      return this.agree_data && this.agree_video;
    },

    locale() {
      return this.$store.state.locale.value;
    },

    agreement_link() {
      return 'https://vcv.' + this.current_domain + '/pages/agreement/';
    },

    user_agreement_link() {
      return 'https://vcv.' + this.current_domain + '/pages/user-agreement/';
    },

    privacy_link() {
      return 'https://vcv.' + this.current_domain + '/pages/privacy-policy/';
    },

    cookies_link() {
      switch (this.current_domain) {
        case 'en':
          return 'https://vcv.ai/pages/cookies-terms';
        case 'ru':
          return 'https://vcv.ru/pages/cookies-terms-ru';
        case 'ja':
          return 'https://vcv.ai/pages/cookies-terms';
        default:
          return 'https://vcv.ai/pages/cookies-terms';
      }
    },

    current_domain() {
      return this.$store.getters['services/current_domain'] || 'ru';
    }
  }
};
</script>

<style lang="scss" scoped>
  .talentq-agreement {
    .flex_center {
      display: flex;
      align-items: center;
    }
    .margin_right {
      margin-right: 10px;
    }
    .agree {
      margin: 30px 0;
    }
  }
</style>
